import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-reference-title',
  templateUrl: './reference-title.component.html',
  styleUrl: './reference-title.component.scss'
})
export class ReferenceTitleComponent implements OnInit {
  @Input() data: any;
  @Input() column: any;

  constructor() {
  }

  ngOnInit(): void {
  }
}
